(() => {
  const root = document.getElementById('d2-configurator');
  if (!root) return;
  document.body.classList.add('d2-show-header');
  const cfg = JSON.parse(document.getElementById('d2Config')?.textContent || '{}');

  const msgEl = document.getElementById('d2Msg');
  const baseSummaryEl = document.getElementById('d2-base-summary');
  const addBtn = document.getElementById('d2AddToCart');

  const finalBaseEl = document.getElementById('d2-final-base');
  const finalExtrasEl = document.getElementById('d2-final-extras');
  const finalTotalEl = document.getElementById('d2-final-total');
const finalMi6Row = document.getElementById('d2-final-mi6-row');
  const stickyBar = document.getElementById('d2StickyBar');
  const stickyTextEl = document.getElementById('d2StickyText');
  const stickyTotalEl = document.getElementById('d2StickyTotal');
  const stickyScrollBtn = document.getElementById('d2StickyScroll');

  const selected = { coil: '28cm', headphones: 'WSA ST', remote: 'Ja' };
  const selectedAddons = new Set();

  const baseInfo = new Map();   // base variant id -> {price, available, name}
  const addonInfo = new Map();  // addon variant id -> {price, available, name}

  const PINPOINTER_ID = String(cfg.ids?.pinpointer || '');
  const HF2_ADDON_ID = String(cfg.ids?.hf2_addon || '');

  const CHEVRON_SVG = `
  <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <path d="M5.5 7.5L10 12l4.5-4.5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
`;

  const groups = {
    coil: root.querySelector('[data-group="coil"]'),
    headphones: root.querySelector('[data-group="headphones"]'),
    remote: root.querySelector('[data-group="remote"]'),
    addons_pinpointer: root.querySelector('[data-group="addons_pinpointer"]'),
    addons_accessories: root.querySelector('[data-group="addons_accessories"]'),
    addons_warranty: root.querySelector('[data-group="addons_warranty"]')
  };

  const norm = (v) => String(v ?? '').trim();
  const headphonesNone = (hp) => norm(hp) === 'Keine';
  const remoteNoAllowedFor = (hp) => norm(hp) === 'WS6 ST';
  const coilIsHF2 = (c) => norm(c) === 'HF2';
  const hasRCSelection = () => norm(selected.remote) === 'Ja';
  const mi6FreeEnabled = !!cfg.mi6Free; // kommt aus Liquid JSON
  const mi6FreeActive = () => mi6FreeEnabled && hasRCSelection();
  const isMasterSelection = () => norm(selected.headphones) === 'WS6 ST' && norm(selected.remote) === 'Nein';

  // Inhalte (Texte + Links) zentral in JS, damit Liquid klein bleibt
const CONTENT = {
  base: {
    coil: [
      {
        value:'22cm',
        title:'22cm',
        text:'Leicht & sehr wendig - ideal für enge Bereiche und viel Schrott.',
        more:'Die 22-cm-Spule ist leicht, sehr wendig und ermöglicht eine sehr genaue Objekt-Ortung. Bei der Tiefe liegt sie etwas hinter größeren Spulen, dafür ist sie bei kleinen Objekten und dichtem Schrott oft im Vorteil. Die Abdeckung pro Schwung ist kleiner, dafür kannst du kontrollierter und ruhiger absuchen.',
        url:'https://www.idc-detektor.de/products/xp-deus-ii-dd-fmf-suchspule-22-cm'
      },
      {
        value:'28cm',
        title:'28cm',
        text:'Allround - gute Tiefe bei guter Trennschärfe.',
        more:'Die 28-cm-Spule ist der ausgewogenste Kompromiss aus Tiefe, Abdeckung, Gewicht und Präzision. Sie sucht spürbar tiefer als die 22-cm-Spule, bleibt aber noch angenehm leicht und gut kontrollierbar. Die Flächenabdeckung ist groß genug für Acker und Wald, ohne dass die Trennschärfe zu stark leidet. Wenn du nur eine Spule willst, ist das für die meisten Suchgebiete die beste Standardwahl.',
        url:'https://www.idc-detektor.de/products/xp-deus-ii-dd-fmf-suchspule-28-cm'
      },
      {
        value:'34cm',
        title:'34cm',
        text:'Mehr Flächenleistung & Tiefe - etwas weniger wendig.',
        more:'Diese große Spule ist gemacht für maximale Abdeckung und starke Tiefe, besonders auf großen Flächen wie Äckern oder Wiesen. Du deckst pro Schwung deutlich mehr Boden ab und kommst oft tiefer an Ziele heran. Dafür ist sie schwerer und weniger wendig, was auf langen Touren mehr Kraft kostet. In stark vermüllten Bereichen ist die Präzision/Trennung meist schwächer als bei kleineren Spulen.',
        url:'https://www.idc-detektor.de/products/xp-deus-ii-dd-fmf-suchspule-34-28-cm'
      },
      {
        value:'HF2',
        title:'HF2 (HF-Spule)',
        text:'Sehr empfindlich auf kleine Objekte und Gold - spezialisiert.',
        more:'Die HF2 ist die Spule für maximale Empfindlichkeit auf sehr kleine Objekte wie feinen Schmuck, dünne Münzen oder Goldnuggets. Sie ist die beste Wahl, wenn du maximale Präzision und saubere Trennung in vermüllten Gebieten brauchst. Durch die elliptische Form arbeitet sie sehr präzise und lässt sich gut zwischen Hindernissen führen. Die Abdeckung ist eher kompakt, dafür bekommst du eine sehr „feine“ Signalerkennung und Kontrolle. Reine Tiefe auf große Objekte ist nicht der Fokus, sie spielt ihre Stärke bei kleinen, schwierigen Objekten und anspruchsvollen Bedingungen aus.',
        url:'https://www.idc-detektor.de/products/xp-deus-ii-dd-fmf-hf2-suchspule-13-24-cm'
      }
    ],
    headphones: [
      {
        value:'WSA ST',
        title:'WSA ST',
        text:'Funk-Kopfhörer: Kompakt - klassisches Setup.',
        more:'Klassische Funk-Kopfhörer-Variante: leicht, unkompliziert.',
        url:'https://www.idc-detektor.de/products/xp-deus-2-funkkopfhorer-wsa-st'
      },
      {
        value:'WSA XL ST',
        title:'WSA XL ST',
        text:'Funk-Kopfhörer: Größer, mehr Komfort und Abschirmung.',
        more:'Mehr Komfort und stärkere Abschirmung der Umgebungsgeräusche durch größere Ohrpolster.',
        url:'https://www.idc-detektor.de/products/xp-deus-2-funkkopfhorer-wsa-xl-st'
      },
      {
        value:'WS6 ST',
        title:'WS6 ST',
        text:'Funk-Kopfhörer mit Display - auch als Steuereinheit nutzbar.',
        more:'WS6 kann auch steuern - dadurch ist ein Master-Setup ohne Fernbedienung möglich.',
        url:'https://www.idc-detektor.de/products/xp-deus-2-funkkopfhorer-ws6-st'
      },
      {
        value:'Keine',
        title:'Keine',
        text:'Ohne XP-Kopfhörer.',
        more:'Sinnvoll, wenn du bewusst ohne XP-Kopfhörer bestellen möchtest oder später ergänzen willst.',
        url:null
      }
    ],
    remote: [
      {
        value:'Ja',
        title:'Fernbedienung',
        text:'Volle Bedienung am Handteil mit Display.',
        more:'Klassisches Deus 2 Komplett-Setup mit Remote Control am Gestänge.',
        url:'https://www.idc-detektor.de/products/xp-deus-2-fernsteuerung'
      },
      {
        value:'Nein',
        title:'Keine Fernbedienung',
        text:'Auswahl nur mit WS6 ST Kopfhörern möglich.',
        more:'Ohne Fernbedienung funktioniert das Setup nur mit WS6 ST Kopfhörern, weil das WS6-Modul dann die Steuerung übernimmt.',
        url:null
      }
    ]
  },

  addons: {
    pinpointer: [
      {
        variantId: PINPOINTER_ID,
        title:'XP MI-6 Pinpointer',
        text:'Schnelleres Finden im Loch und beim Ausgraben.',
        more:'Bei allen Sets mit Fernbedienung ist der MI-6 aktuell gratis enthalten.',
        url:'https://www.idc-detektor.de/products/xp-mi-6-pinpointer'
      }
    ],
    accessories: [
      {
        variantId:'50915326427483',
        title:'XP DEUS II DD FMF HF2 Suchspule 13 x 24 cm',
        text:'Zusatzspule für spezielle Einsatzbereiche.',
        more:'Wenn HF2 oben bereits gewählt ist, ist diese Option hier deaktiviert.',
        url:'https://www.idc-detektor.de/products/xp-deus-ii-dd-fmf-hf2-suchspule-13-24-cm'
      },
      {
        variantId:'50915239199067',
        title:'XP Knochenschall-Kopfhörer',
        text:'Offenes Hören - Umgebung bleibt wahrnehmbar.',
        more:'Besonders interessant, wenn du die Umgebung besser hören möchtest.',
        url:'https://www.idc-detektor.de/products/xp-deus-ii-knochenschall-kopfhorer'
      },
      {
        variantId:'50915279962459',
        title:'XP Profi Rucksack',
        text:'Transportlösung für Detektor & Zubehör.',
        more:'Praktischer Rucksack für Transport und Aufbewahrung.',
        url:'https://www.idc-detektor.de/products/xp-profi-rucksack'
      },
      {
        variantId:'50914822881627',
        title:'XP Rucksack 240',
        text:'Großer Rucksack für mehr Ausrüstung.',
        more:'Mehr Stauraum für umfangreiches Zubehör und längere Einsätze.',
        url:'https://www.idc-detektor.de/products/xp-basic-240-rucksack'
      },
      {
        variantId:'50915249422683',
        title:'XP Fundtasche',
        text:'Praktisch für Funde & Werkzeug.',
        more:'Praktische Tasche für Funde, Kleinteile und Werkzeug.',
        url:'https://www.idc-detektor.de/products/xp-fundtasche'
      },
      {
        variantId:'50915287105883',
        title:'XP Xtreme Hunter Spule',
        text:'Optionales Extra für maximale Tiefe.',
        more:'Spezialzubehör für besondere Anforderungen.',
        url:'https://www.idc-detektor.de/products/xp-xtrem-hunter-xtr-115-tiefensuchspule-als-deus-ii-erganzung'
      }
    ],
    warranty: [
      {
        variantId:'52006591627611',
        title:'Garantieverlängerung (5 zusätzliche Jahre) für den XP DEUS II Metalldetektor',
        text:'Optionaler Zusatzschutz für den Detektor, die Suchspule und die Kopfhörer.',
        more:'Sinnvoll, wenn du deinen Deus 2 langfristig absichern möchtest.',
        url:'https://www.idc-detektor.de/products/garantieverlangerung-5-zusatzliche-jahre-fur-den-xp-deus-ii-metalldetektor'
      },
      {
        variantId:'52006576226651',
        title:'Garantieverlängerung (5 zusätzliche Jahre) für XP FMF Suchspulen',
        text:'Optionaler Zusatzschutz für deine Suchspule.',
        more:'Zusätzlicher Schutz für kompatible XP FMF Suchspulen.',
        url:'https://www.idc-detektor.de/products/garantieverlangerung-5-zusatzliche-jahre-fur-xp-fmf-suchspulen'
      }
    ],
    masterHeadphones: [
      {
        variantId:String(cfg.ids?.wsa_st_accessory_master||''),
        title:'XP DEUS 2 Funkkopfhörer WSA ST',
        text:'Optionaler Zusatz-Kopfhörer für Master-Sets.',
        more:'Nur sichtbar, wenn ein Master-Set ohne Fernbedienung gewählt wurde.',
        url:'https://www.idc-detektor.de/products/xp-deus-2-funkkopfhorer-wsa-st'
      },
      {
        variantId:String(cfg.ids?.wsa_xl_accessory_master||''),
        title:'XP DEUS 2 Funkkopfhörer WSA XL ST',
        text:'Optionaler Zusatz-Kopfhörer mit mehr Komfort.',
        more:'Nur sichtbar, wenn ein Master-Set ohne Fernbedienung gewählt wurde.',
        url:'https://www.idc-detektor.de/products/xp-deus-2-funkkopfhorer-wsa-xl-st'
      }
    ]
  }
};

  // base lookup
  const baseLookup = new Map();
  (cfg.baseCombos || []).forEach(x => {
    const key = `${norm(x.coil)}|${norm(x.headphones)}|${norm(x.remote)}`;
    baseLookup.set(key, String(x.variantId || '').trim());
  });
  const baseKey = (sel) => `${norm(sel.coil)}|${norm(sel.headphones)}|${norm(sel.remote)}`;
  const getBaseVariantId = (sel) => baseLookup.get(baseKey(sel)) || null;

  function labelRemote(val){ return norm(val)==='Ja' ? 'Fernbedienung' : 'Keine Fernbedienung'; }

  function formatMoney(cents){
    const amount = Number(cents)/100;
    try{
      return new Intl.NumberFormat('de-DE',{style:'currency',currency:cfg.currencyCode||'EUR'}).format(amount);
    }catch(e){
      return amount.toFixed(2).replace('.',',')+' €';
    }
  }
  function formatDelta(diff){
    if (diff === 0) return '±0 €';
    const sign = diff > 0 ? '+' : '−';
    return sign + formatMoney(Math.abs(diff));
  }

  async function fetchVariantInfo(id){
    const res = await fetch(`/variants/${id}.js`, { headers:{'Accept':'application/json'} });
    if(!res.ok) return null;
    const data = await res.json();
    return { price:Number(data.price||0), available:!!data.available, name:data.name||data.title||'' };
  }

  async function preloadAllVariantInfos(){
    const baseIds = new Set();
    (cfg.baseCombos || []).forEach(x => {
      const id = String(x.variantId||'').trim();
      if (/^\d+$/.test(id)) baseIds.add(id);
    });

    const addonIds = new Set();
    (cfg.addons?.pinpointer||[]).concat(cfg.addons?.accessories||[], cfg.addons?.warranty||[], cfg.addons?.masterHeadphones||[])
      .forEach(x => {
        const id = String(x.variantId||'').trim();
        if (/^\d+$/.test(id)) addonIds.add(id);
      });

    await Promise.all([
      ...Array.from(baseIds).map(async (id)=>{ try{ const info=await fetchVariantInfo(id); if(info) baseInfo.set(id,info);}catch(_){} }),
      ...Array.from(addonIds).map(async (id)=>{ try{ const info=await fetchVariantInfo(id); if(info) addonInfo.set(id,info);}catch(_){} })
    ]);
  }

  function normalizeSelection(){
    if (!selected.coil) selected.coil='28cm';
    if (!selected.headphones) selected.headphones='WSA ST';
    if (!selected.remote) selected.remote='Ja';

    if (norm(selected.remote)==='Nein' && !remoteNoAllowedFor(selected.headphones)) selected.remote='Ja';
    if (headphonesNone(selected.headphones)) selected.remote='Ja';

    if (coilIsHF2(selected.coil)){
      selected.headphones='WSA ST';
      selected.remote='Ja';
    }

    if (coilIsHF2(selected.coil) && selectedAddons.has(HF2_ADDON_ID)) selectedAddons.delete(HF2_ADDON_ID);

    // Promo: MI-6 gratis bei allen Sets mit Fernbedienung => nicht auswählbar
    if (hasRCSelection() && selectedAddons.has(PINPOINTER_ID)) selectedAddons.delete(PINPOINTER_ID);
  }

  function simulateSelection(groupKey, value){
    const tmp = { coil:selected.coil, headphones:selected.headphones, remote:selected.remote };
    tmp[groupKey]=value;

    if (norm(tmp.remote)==='Nein' && !remoteNoAllowedFor(tmp.headphones)) tmp.remote='Ja';
    if (headphonesNone(tmp.headphones)) tmp.remote='Ja';
    if (coilIsHF2(tmp.coil)){ tmp.headphones='WSA ST'; tmp.remote='Ja'; }

    return tmp;
  }

  function getSelectionInfo(sel){
    const id = getBaseVariantId(sel);
    if(!id) return { id:null, info:null, available:false };
    const info = baseInfo.get(id) || null;
    return { id, info, available: info ? !!info.available : true };
  }

function isChoicePossible(groupKey, candidateValue){
  // HF2: In Schritt 2 dürfen nur WSA ST auswählbar sein
  if (groupKey === 'headphones' && coilIsHF2(selected.coil) && norm(candidateValue) !== 'WSA ST') {
    return false;
  }

  // "Keine Fernbedienung" darf nur mit WS6 ST überhaupt auswählbar sein
  if (groupKey === 'remote' && norm(candidateValue) === 'Nein' && !remoteNoAllowedFor(selected.headphones)) {
    return false;
  }

  const tmp = simulateSelection(groupKey, candidateValue);
  const { id, info } = getSelectionInfo(tmp);

  if(!id) return false;
  if(!info) return true;
  return !!info.available;
}

function getPriceDeltaText(groupKey, candidateValue){
  // Bei Schritt 1 keine +/- Preise anzeigen
  if (groupKey === 'coil') return '';

  // HF2: gesperrte Kopfhörer bekommen auch keine Preisänderung
  if (groupKey === 'headphones' && coilIsHF2(selected.coil) && norm(candidateValue) !== 'WSA ST') {
    return '';
  }

  // Bei "Keine Fernbedienung" nichts anzeigen, wenn aktuell nicht erlaubt
  if (groupKey === 'remote' && norm(candidateValue) === 'Nein' && !remoteNoAllowedFor(selected.headphones)) {
    return '';
  }

  if (norm(selected[groupKey]) === norm(candidateValue)) return '';

  const current = getSelectionInfo(selected);
  const candSel = simulateSelection(groupKey, candidateValue);
  const cand = getSelectionInfo(candSel);

  if(!current.id || !cand.id) return '';
  if(!current.info || !cand.info) return 'Preis wird geladen…';
  if(!cand.available) return '';

  return formatDelta(cand.info.price - current.info.price);
}

  function renderBaseGroup(groupKey){
    const host = groups[groupKey];
    if(!host) return;
    host.innerHTML = '';

    const block = document.createElement('div');
    block.className = 'd2-base-group';

    // responsive picture (desktop/mobile)
    const imgWrap = document.createElement('div');
    imgWrap.className = 'd2-shared-image-wrap';

    const picture = document.createElement('picture');
    const s = document.createElement('source');
    s.media = '(min-width: 820px)';
    s.srcset = cfg.sharedImages?.[groupKey]?.desktop || '';
    const img = document.createElement('img');
    img.className = 'd2-shared-image';
    img.loading = 'lazy';
    img.alt = groupKey;
    img.src = cfg.sharedImages?.[groupKey]?.mobile || cfg.sharedImages?.[groupKey]?.desktop || '';
    img.onerror = () => { imgWrap.style.display='none'; };

    picture.appendChild(s);
    picture.appendChild(img);
    imgWrap.appendChild(picture);
    block.appendChild(imgWrap);

    const list = document.createElement('div');
    list.className = 'd2-option-list';

    (CONTENT.base[groupKey] || []).forEach(item => {
      const selectedState = norm(selected[groupKey])===norm(item.value);
      const possible = isChoicePossible(groupKey, item.value);
      const statusText = possible ? 'Wählbar' : 'Nicht verfügbar';
      const deltaText = getPriceDeltaText(groupKey, item.value);

      const wrap = document.createElement('div');
      wrap.className = 'd2-option-item' + (selectedState ? ' is-selected':'') + (!possible ? ' is-disabled':'');
      wrap.setAttribute('role','button');
      wrap.setAttribute('tabindex', !possible ? '-1':'0');

      if (selectedState){
        const b = document.createElement('div');
        b.className='d2-selected-badge';
        b.textContent='Ausgewählt';
        wrap.appendChild(b);
      }

      const top = document.createElement('div');
      top.className='d2-option-top';

      const main = document.createElement('div');
      main.className='d2-option-main';

      const titleRow = document.createElement('div');
      titleRow.className='d2-option-title-row';

      const t = document.createElement('div');
      t.className='d2-option-title';
      t.textContent=item.title;

      const st = document.createElement('span');
      st.className='d2-status-badge' + (!possible ? ' is-disabled':'');
      st.textContent=statusText;

      titleRow.appendChild(t);
      titleRow.appendChild(st);

      const short = document.createElement('div');
      short.className='d2-option-short';
      short.textContent=item.text;

      main.appendChild(titleRow);
      main.appendChild(short);

      if (deltaText && !selectedState){
        const d = document.createElement('div');
        d.className='d2-option-delta';
        if (deltaText.startsWith('+')) d.classList.add('is-positive');
        if (deltaText.startsWith('−')) d.classList.add('is-negative');
        d.textContent=deltaText;
        main.appendChild(d);
      }

      const infoBtn = document.createElement('button');
      infoBtn.type='button';
      infoBtn.className='d2-info-btn';
      infoBtn.innerHTML = CHEVRON_SVG;
      infoBtn.setAttribute('aria-label','Mehr Infos');

      top.appendChild(main);
      top.appendChild(infoBtn);

      const extra = document.createElement('div');
      extra.className='d2-option-extra';
      extra.innerHTML = `${item.more ? `<div>${item.more}</div>`:''}${item.url ? `<a class="d2-option-link" href="${item.url}" target="_blank" rel="noopener">Produkt ansehen</a>`:''}`;

      infoBtn.addEventListener('click',(e)=>{
        e.stopPropagation();
        wrap.classList.toggle('is-open');
        
      });

      wrap.appendChild(top);
      wrap.appendChild(extra);

      const choose = ()=>{
        if(!possible) return;
        selected[groupKey]=item.value;
        normalizeSelection();
        updateAll();
      };

      wrap.addEventListener('click', choose);
      wrap.addEventListener('keydown',(e)=>{ if(e.key==='Enter'||e.key===' ') choose(); });

      list.appendChild(wrap);
    });

    block.appendChild(list);
    host.appendChild(block);
  }

  function buildAccessoryItems(){
    const base = (CONTENT.addons.accessories || []).map(x => ({...x}));
    if (isMasterSelection()){
      const m1 = String(cfg.ids?.wsa_st_accessory_master||'').trim();
      const m2 = String(cfg.ids?.wsa_xl_accessory_master||'').trim();
      if (/^\d+$/.test(m1)) base.push(CONTENT.addons.masterHeadphones[0]);
      if (/^\d+$/.test(m2)) base.push(CONTENT.addons.masterHeadphones[1]);
    }
    return base;
  }

  function renderAddonGroup(hostKey, items, multi){
    const host = groups[hostKey];
    if(!host) return;
    host.innerHTML='';

    const rc = hasRCSelection();
    const hf = coilIsHF2(selected.coil);

    items.forEach((item, idx) => {
      const vid = String(item.variantId||'').trim();
      const valid = /^\d+$/.test(vid);
      let forcedDisabled = false;
      let specialText = '';
      let promoLocked = false; // z.B. MI-6 gratis enthalten -> normal anzeigen, aber nicht auswählbar
      if (vid === HF2_ADDON_ID && hf) forcedDisabled = true;

    // Promo: MI-6 ist bei Sets mit Fernbedienung inklusive (nur Anzeige, kein Addon)
if (vid === PINPOINTER_ID && rc && cfg.mi6Free){
  promoLocked = true;
  specialText = 'Inklusive';
}

// Wichtig: MI-6 darf NICHT in selectedAddons, sonst würde er in den echten Warenkorb gehen
if ((forcedDisabled || promoLocked) && selectedAddons.has(vid)) selectedAddons.delete(vid);

// Visuell "selected", aber ohne echtes Addon
const isSel = !forcedDisabled && (selectedAddons.has(vid) || promoLocked);
      const statusText = !valid ? 'ID fehlt' : (specialText ? specialText : (forcedDisabled ? 'Nicht verfügbar' : 'Optional'));

      // Bild aus cfg.addons[...] nehmen (damit es pro Shop passt)
      let imgUrl = '';
      const findImg = () => {
        const all = []
          .concat(cfg.addons?.pinpointer||[])
          .concat(cfg.addons?.accessories||[])
          .concat(cfg.addons?.warranty||[])
          .concat(cfg.addons?.masterHeadphones||[]);
        const row = all.find(x => String(x.variantId||'').trim() === vid);
        return row ? row.img : '';
      };
      imgUrl = findImg();

      const el = document.createElement('div');
      el.className = 'd2-card' + (isSel ? ' is-selected':'');
      if (promoLocked) el.className += ' is-locked';
      el.setAttribute('role','button');
// Nur wirklich deaktivierte Items ausgrauen/disable (promoLocked bleibt "normal")
el.setAttribute('tabindex', (!valid || forcedDisabled) ? '-1' : '0');
el.setAttribute('aria-disabled', (!valid || forcedDisabled) ? 'true' : 'false');

      if (isSel){
        const b = document.createElement('div');
        b.className='d2-selected-badge';
        b.textContent = promoLocked ? 'Inklusive' : 'Ausgewählt';
        el.appendChild(b);
      }

      const img = document.createElement('img');
      img.className='d2-img';
      img.loading='lazy';
      img.alt=item.title||'';
      img.src=imgUrl||'';
      el.appendChild(img);

      const body = document.createElement('div');
      body.className='d2-body';

      const top = document.createElement('div');
      top.className='d2-top';

      const titleWrap = document.createElement('div');
      titleWrap.className='d2-title-row';

      const t = document.createElement('div');
      t.className='d2-title';
      t.textContent=item.title||'';

      const st = document.createElement('span');
      st.className='d2-status-badge' + ((!valid || forcedDisabled) ? ' is-disabled':'');
      st.textContent=statusText;

      titleWrap.appendChild(t);
      titleWrap.appendChild(st);

      const infoBtn = document.createElement('button');
      infoBtn.type='button';
      infoBtn.className='d2-info-btn';
      infoBtn.innerHTML = CHEVRON_SVG;
      infoBtn.setAttribute('aria-label','Mehr Infos');

      top.appendChild(titleWrap);
      top.appendChild(infoBtn);

      const txt = document.createElement('div');
      txt.className='d2-text';
      txt.textContent=item.text||'';

      body.appendChild(top);
      body.appendChild(txt);

      // Preis / Gratis-Info
      const p = document.createElement('div');
      p.className='d2-mini-price';
      if (promoLocked){
  const info = addonInfo.get(vid);
  if (info){
    p.innerHTML = `<span class="d2-price-strike">${formatMoney(info.price)}</span><span class="d2-price-free">Gratis</span>`;
  } else {
    p.textContent = 'Preis wird geladen…';
  }
} else if (valid){
  const info = addonInfo.get(vid);
  p.textContent = info ? ('Preis: ' + formatMoney(info.price)) : 'Preis wird geladen…';
}
      body.appendChild(p);

      const extra = document.createElement('div');
      extra.className='d2-card-extra';
      extra.innerHTML = `${item.more ? `<div>${item.more}</div>`:''}${item.url ? `<a class="d2-option-link" href="${item.url}" target="_blank" rel="noopener">Produkt ansehen</a>`:''}`;
      body.appendChild(extra);

      infoBtn.addEventListener('click',(e)=>{
        e.stopPropagation();
        el.classList.toggle('is-open');
        
      });

      el.appendChild(body);

      const toggle = ()=>{
        if(!valid || forcedDisabled || promoLocked) return;

        if (!multi){
          if (selectedAddons.has(vid)) selectedAddons.delete(vid);
          else {
            items.forEach(x => selectedAddons.delete(String(x.variantId||'').trim()));
            selectedAddons.add(vid);
          }
        } else {
          if (selectedAddons.has(vid)) selectedAddons.delete(vid);
          else selectedAddons.add(vid);
        }
        updateAll();
      };

      el.addEventListener('click', toggle);
      el.addEventListener('keydown', (e)=>{ if(e.key==='Enter'||e.key===' ') toggle(); });

      host.appendChild(el);
    });
  }

  function selectedAddonTitles(){
    const all = []
      .concat(CONTENT.addons.pinpointer||[])
      .concat(buildAccessoryItems())
      .concat(CONTENT.addons.warranty||[]);
    const titles = [];
    for (const id of selectedAddons){
      const it = all.find(x => String(x.variantId).trim() === String(id).trim());
      if (it && it.title) titles.push(it.title);
    }
    return titles;
  }

  function calcAddonsTotalCents(){
    let sum = 0;
    let missing = 0;
    for (const id of selectedAddons){
      const info = addonInfo.get(String(id));
      if (info && typeof info.price === 'number') sum += info.price;
      else missing += 1;
    }
    return { sum, missing };
  }

  function updateSummary(baseId){
    const info = baseId ? baseInfo.get(baseId) : null;
    const baseText = info ? formatMoney(info.price) : 'Preis wird geladen…';
    baseSummaryEl.innerHTML = baseId
      ? `Auswahl: <strong>${selected.coil}</strong> • <strong>${selected.headphones}</strong> • <strong>${labelRemote(selected.remote)}</strong>
         <div class="d2-price">Basispreis: ${baseText}</div>`
      : `Bitte eine gültige Konfiguration wählen.`;
  }

  function updateFinalAndSticky(baseId){
    if (finalMi6Row) finalMi6Row.style.display = mi6FreeActive() ? '' : 'none';
    const baseText = `${selected.coil} • ${selected.headphones} • ${labelRemote(selected.remote)}`;
    finalBaseEl.textContent = baseText;

    let extras = selectedAddonTitles();

// Wenn RC gewählt und Promo aktiv ist: Hinweis anzeigen (ohne Addon in den Warenkorb zu legen)


finalExtrasEl.innerHTML = extras.length
  ? `<ul class="d2-final-list">${extras.map(t=>`<li>${t}</li>`).join('')}</ul>`
  : 'Keine Extras ausgewählt';

    const baseObj = baseId ? baseInfo.get(baseId) : null;
    const baseCents = baseObj ? Number(baseObj.price||0) : 0;
    const { sum: addonsCents, missing } = calcAddonsTotalCents();
    const totalCents = baseCents + addonsCents;

    let totalText = '—';
    if (baseId){
      if (!baseObj || missing > 0) totalText = 'Preis wird geladen…';
      else totalText = formatMoney(totalCents);
    }

    finalTotalEl.textContent = totalText;
    stickyTextEl.textContent = baseText;
    stickyTotalEl.textContent = totalText;
  }

  function applyPreset(key){
    const p = cfg.presets?.[key];
    if(!p) return;

    // Markierung
    document.querySelectorAll('#d2PresetGrid [data-preset]').forEach(btn=>{
      btn.classList.toggle('is-selected', btn.getAttribute('data-preset')===key);
    });

    selected.coil = p.coil;
    selected.headphones = p.headphones;
    selected.remote = p.remote;

    selectedAddons.clear();
    (p.addons||[]).forEach(id=>selectedAddons.add(String(id)));

    normalizeSelection();
    updateAll();
  }

function hookPresetButtons(){
  document.querySelectorAll('#d2PresetGrid [data-preset]').forEach(btn=>{
    // Klick auf Karte = Preset anwenden (außer wenn auf Info-Button geklickt wurde)
    btn.addEventListener('click', (e)=>{
      if (e.target.closest('.d2-preset-info')) return;
      applyPreset(btn.getAttribute('data-preset'));
    });

    // Klick auf Info-Button = Dropdown öffnen/schließen
    const info = btn.querySelector('.d2-preset-info');
    if (info){
      info.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('is-open');
      });
    }
  });
}

  function updateAll(){
    normalizeSelection();

    const baseId = getBaseVariantId(selected);
    const baseObj = baseId ? baseInfo.get(baseId) : null;
    const baseOk = baseId && (baseObj ? !!baseObj.available : true);

    renderBaseGroup('coil');
    renderBaseGroup('headphones');
    renderBaseGroup('remote');

    renderAddonGroup('addons_pinpointer', CONTENT.addons.pinpointer, false);
    renderAddonGroup('addons_accessories', buildAccessoryItems(), true);
    renderAddonGroup('addons_warranty', CONTENT.addons.warranty, false);

    updateSummary(baseOk ? baseId : null);
    updateFinalAndSticky(baseOk ? baseId : null);

    msgEl.textContent = '';
    return baseOk ? baseId : null;
  }

  function openDrawerOrGoCart(){
    const drawer = document.querySelector('cart-drawer');
    if (drawer){
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof drawer.show === 'function') drawer.show();
      else drawer.setAttribute('open','');
    } else {
      window.location.href = '/cart';
    }
  }

  async function refreshDrawer(cart){
    try{
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
      document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{cart}}));
    }catch(_){}

    try{
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      if (typeof drawer.renderContents === 'function') drawer.renderContents(cart);
      else if (typeof drawer.refresh === 'function') await drawer.refresh();
    }catch(_){}
  }

async function addToCart(){
  const baseId = updateAll();
  if (!baseId){
    msgEl.textContent = 'Diese Konfiguration ist aktuell nicht verfügbar.';
    return;
  }

  const items = [{ id:Number(baseId), quantity:1 }];
  for (const vid of selectedAddons){
    if (/^\d+$/.test(String(vid))) items.push({ id:Number(vid), quantity:1 });
  }

  addBtn.disabled = true;
  msgEl.textContent = 'Wird hinzugefügt…';

  try{
    // ✅ Marker setzen: Konfigurator genutzt (landet als Order-Attribute in der Bestellung)
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          idc_source: 'deus2_configurator',
          deus2_coil: selected.coil || '',
          deus2_headphones: selected.headphones || '',
          deus2_remote: selected.remote || ''
        }
      })
    });

    const res = await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({ items })
    });
    if(!res.ok) throw new Error(await res.text());

    try {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'deus2_configurator_add_to_cart', {
      idc_source: 'deus2_configurator',
      deus2_coil: selected.coil || '',
      deus2_headphones: selected.headphones || '',
      deus2_remote: selected.remote || '',
      base_variant_id: Number(baseId),
      addons: Array.from(selectedAddons || []).map(v => Number(v)).filter(Number.isFinite).join(',')
    });
  }
} catch (_) {}

    let cart = null;
    try{
      const cartRes = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
      cart = await cartRes.json();
    }catch(_){}

    await refreshDrawer(cart);
    msgEl.textContent = '';
    openDrawerOrGoCart();
  }catch(e){
    console.error(e);
    msgEl.textContent = 'Konnte nicht hinzugefügt werden. Bitte Verfügbarkeit prüfen.';
  }finally{
    addBtn.disabled = false;
  }
}

function initStickyBar(){
  if (!stickyBar || !addBtn) return;

  const step1El = groups.coil?.closest('.d2-step');
  let passedStep1 = false;
  let addBtnVisible = false;

  // Balken am Anfang immer verstecken
  stickyBar.classList.add('is-hidden');

  stickyScrollBtn?.addEventListener('click', ()=>{
    addBtn.scrollIntoView({behavior:'smooth',block:'center'});
  });

  function updateStickyState(){
    if (!passedStep1 || addBtnVisible) stickyBar.classList.add('is-hidden');
    else stickyBar.classList.remove('is-hidden');
  }

  // Sobald Schritt 1 einmal erreicht wurde, darf der Balken angezeigt werden
  function checkStep1(){
    if (!step1El || passedStep1) return;
    const rect = step1El.getBoundingClientRect();
    if (rect.top <= window.innerHeight * 0.9) {
      passedStep1 = true;
      updateStickyState();
    }
  }

  const btnObserver = new IntersectionObserver((entries)=>{
    const e = entries[0];
    if(!e) return;
    addBtnVisible = e.isIntersecting && e.intersectionRatio > 0.25;
    updateStickyState();
  }, { threshold:[0,0.25,0.5,1] });

  btnObserver.observe(addBtn);

  checkStep1();
  window.addEventListener('scroll', checkStep1, { passive:true });
}

  function initHeaderScrollBehavior(){
    let lastY = window.scrollY || 0;
    let ticking = false;

    const apply = (dir)=>{
      if (dir==='down'){
        document.body.classList.add('d2-hide-header');
        document.body.classList.remove('d2-show-header');
      } else {
        document.body.classList.add('d2-show-header');
        document.body.classList.remove('d2-hide-header');
      }
    };

    window.addEventListener('scroll', ()=>{
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(()=>{
        const y = window.scrollY || 0;
        const dir = (y > lastY + 6) ? 'down' : (y < lastY - 6) ? 'up' : null;
        if (dir) apply(dir);
        lastY = y;
        ticking = false;
      });
    }, { passive:true });
  }

  hookPresetButtons();
  initStickyBar();
  initHeaderScrollBehavior();

  updateAll();
  preloadAllVariantInfos().then(()=>updateAll());

  addBtn.addEventListener('click', addToCart);
})();